module.exports = __webpack_public_path__ + "img/4-1.012aabf1.png";